// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.mjs";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as AuthConfig$PorterinFeature from "../config/AuthConfig.mjs";
import * as AuthHelper$PorterinFeature from "../helpers/AuthHelper.mjs";
import * as NetworkUtils$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/NetworkUtils.mjs";
import * as NetworkHelper$PorterinFeature from "../../../../shared/core/helpers/NetworkHelper.mjs";
import * as AuthRepoConfig$PorterinFeature from "./AuthRepoConfig.mjs";

function checkCustomerExists(web_tracking_id, mobile, query_params) {
  var match = AuthHelper$PorterinFeature.customerExistsApiCallInfo(web_tracking_id, mobile, query_params);
  var request_url = match[0];
  return NetworkUtils$PorterinUtils.catchPromiseError(Js_promise.then_((function (result) {
                    return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                                return Curry._1(AuthRepoConfig$PorterinFeature.CustomerExistsResponseConverter.execute, result);
                              });
                  }), NetworkV2$Catalyst.post(request_url, Caml_option.some(match[1]), match[2], undefined, undefined, undefined, undefined)), request_url);
}

function customerSignUp(web_tracking_id, mobile, email) {
  var match = AuthHelper$PorterinFeature.customerSignUpApiCallInfo(web_tracking_id, mobile, email);
  var request_url = match[0];
  return NetworkUtils$PorterinUtils.catchPromiseError(Js_promise.then_((function (result) {
                    return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                                return Curry._1(AuthRepoConfig$PorterinFeature.SignupResponseConverter.execute, result);
                              });
                  }), NetworkV2$Catalyst.post(request_url, Caml_option.some(match[1]), match[2], undefined, undefined, undefined, undefined)), request_url);
}

function validateOtp(web_tracking_id, mobile, email, otp, name, whatsapp_consent, customer_frequency, agreed_docs, referral_code, geo_region_id) {
  var headers = AuthHelper$PorterinFeature.createHeader(web_tracking_id);
  var payload = Config$PorterinUtils.agreed_docs_login_flag ? JSON.stringify(AuthHelper$PorterinFeature.createOtpValidationPayload(mobile, email, otp, name, whatsapp_consent, customer_frequency, agreed_docs, referral_code, geo_region_id)) : JSON.stringify(AuthHelper$PorterinFeature.createValidateOtpPayload(mobile, email, otp, name, whatsapp_consent, customer_frequency, referral_code, geo_region_id));
  return NetworkUtils$PorterinUtils.catchPromiseError(Js_promise.then_((function (result) {
                    return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                                return Curry._1(AuthRepoConfig$PorterinFeature.OtpValidationResponseConverter.execute, result);
                              });
                  }), NetworkV2$Catalyst.post(AuthConfig$PorterinFeature.customer_validate_otp, Caml_option.some(headers), payload, undefined, undefined, undefined, undefined)), AuthConfig$PorterinFeature.customer_validate_otp);
}

function resendOtp(web_tracking_id, mobile, option) {
  var requestUrl = option !== undefined && !option ? AuthConfig$PorterinFeature.customer_resend_whatsapp_otp : AuthConfig$PorterinFeature.customer_resend_sms_otp;
  var headers = AuthHelper$PorterinFeature.createHeader(web_tracking_id);
  var payload = JSON.stringify(AuthHelper$PorterinFeature.createResendOtpPayload(mobile));
  return NetworkUtils$PorterinUtils.catchPromiseError(Js_promise.then_((function (result) {
                    return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                                return Curry._1(AuthRepoConfig$PorterinFeature.ResendOtpResponseConverter.execute, result);
                              });
                  }), NetworkV2$Catalyst.post(requestUrl, Caml_option.some(headers), payload, undefined, undefined, undefined, undefined)), requestUrl);
}

function customerLogout(web_tracking_id, auth_token, mobile) {
  var headers = AuthHelper$PorterinFeature.createAuthenticatedHeaders(web_tracking_id, auth_token, mobile);
  var updatedHeaders = NetworkHelper$PorterinFeature.assignLocaleHeaders(headers);
  return NetworkUtils$PorterinUtils.catchPromiseError(Js_promise.then_((function (result) {
                    return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                                return Curry._1(AuthRepoConfig$PorterinFeature.CustomerLogoutResponseConverter.execute, result);
                              });
                  }), NetworkV2$Catalyst.post(AuthConfig$PorterinFeature.customer_logout, Caml_option.some(updatedHeaders), "", undefined, undefined, undefined, undefined)), AuthConfig$PorterinFeature.customer_logout);
}

function customerProfile(web_tracking_id, auth_token, mobile) {
  var headers = AuthHelper$PorterinFeature.createAuthenticatedHeaders(web_tracking_id, auth_token, mobile);
  var updatedHeaders = NetworkHelper$PorterinFeature.assignLocaleHeaders(headers);
  return NetworkUtils$PorterinUtils.catchPromiseError(Js_promise.then_((function (result) {
                    return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                                return Curry._1(AuthRepoConfig$PorterinFeature.CustomerProfileResponseConverter.execute, result);
                              });
                  }), NetworkV2$Catalyst.get(AuthConfig$PorterinFeature.customer_profile, Caml_option.some(updatedHeaders), undefined, undefined, undefined, undefined)), AuthConfig$PorterinFeature.customer_profile);
}

export {
  checkCustomerExists ,
  customerSignUp ,
  validateOtp ,
  resendOtp ,
  customerLogout ,
  customerProfile ,
}
/* NetworkV2-Catalyst Not a pure module */
